import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import du logger pour l'initialiser au démarrage
import './utils/logger';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// En production, on désactive les logs de performance
if (process.env.NODE_ENV !== 'production') {
  reportWebVitals(console.log);
}
